import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const PrivacyPolicy = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfService = lazy(() => import('../pages/terms-of-service/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfService />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
